import React, { Component } from 'react';
import { Layout, Menu as AntMenu, Row, Col, Avatar } from 'antd';
import { NavLink } from 'react-router-dom'
import PrivateRoute from '../../components/PrivateRoute';
import NotFound from '../../components/404';
import { RecipeList, Recipe } from './components/recipe'
import { MenuList, Menu, CustomerMenu } from './components/menu'
import { GroceryListList, GroceryList } from './components/grocery-list'
import { Profile, Payment } from './components/profile'
import { Switch } from 'react-router';

const { Content, Header, Footer } = Layout;

export default class Dasboard extends Component {
    render() {
        let selectedKeys = [];
        if (window.location.pathname.split('/').length > 1) {
            let pathPrefix = window.location.pathname.split('/')[1];
            if (pathPrefix === 'customers') {
                pathPrefix = 'menus';
            }
            selectedKeys.push('/' + pathPrefix);
        }

        return (
            <Layout>
                <Header style={{ background: '#fff' }}>
                    <Row>
                        <Col xs={6} sm={2}>
                            <div>
                                <NavLink to="/menus">
                                    <img width="50" src={process.env.REACT_APP_CDN_URL + '/assets/logo.png'} alt="Varma logga"/>
                                </NavLink>
                            </div>    
                        </Col>
                        <Col xs={14} sm={16}>
                            <AntMenu 
                                theme="light" 
                                mode="horizontal" 
                                selectedKeys={selectedKeys}
                                style={{ lineHeight: '64px' }}
                            >
                                <AntMenu.Item key="/menus">
                                    <NavLink to="/menus">
                                        <span className="nav-text">Menyer</span>
                                    </NavLink>
                                </AntMenu.Item>
                                <AntMenu.Item key="/recipes">
                                    <NavLink to="/recipes">
                                        <span className="nav-text">Recept</span>
                                    </NavLink>
                                </AntMenu.Item>
                                <AntMenu.Item key="/groceries">
                                    <NavLink to="/groceries">
                                        <span className="nav-text">Inköpslistor</span>
                                    </NavLink>
                                </AntMenu.Item>
                            </AntMenu>
                        </Col>
                        <Col xs={4} sm={6}>
                            <Row type="flex" justify="end" align="middle">
                                <NavLink to="/profile">
                                    <div style={{ textAlign: 'right' }} className="avatar-container">
                                        <Avatar style={{ backgroundColor: '#EF7C39' }} icon="user" />
                                        <span style={{ marginLeft: '10px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.65)' }} className="profile-name">
                                            {this.props.customer}
                                        </span>
                                    </div>
                                </NavLink>
                            </Row>
                        </Col>
                    </Row>
                </Header>
                <Content>
                    <div style={{ background: '#fff', padding: 24, minHeight: 280 }}>
                        <Switch>
                            <PrivateRoute path='/recipes/:id' component={Recipe} />
                            <PrivateRoute path='/recipes' component={RecipeList} />
                            <PrivateRoute path='/menus/:menuId' component={Menu} />
                            <PrivateRoute path='/customers/:id/menus/:menuId' component={CustomerMenu} />
                            <PrivateRoute path='/menus' component={MenuList} />
                            <PrivateRoute path='/groceries/:id' component={GroceryList} />
                            <PrivateRoute path='/groceries' component={GroceryListList} />
                            <PrivateRoute path='/profile/payment' component={Payment} />
                            <PrivateRoute path='/profile' component={Profile} />
                            <PrivateRoute path='/404' component={NotFound} />
                            <PrivateRoute path='/' component={MenuList} />
                        </Switch>
                    </div>
                </Content>
                <Footer style={{ textAlign: 'center' }}>
                    Varma Sverige AB ©2018
                </Footer>
            </Layout>      
        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/dashboard/index.js